export default "__VITE_ASSET__CptSrpbj__"